/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { PlatformStatsPlatform, PlatformStatsPlatformApiSubType } from "~/features/statistics/types";

const transformToPlatformStatsPlatform = (platform: PlatformStatsPlatformApiSubType): PlatformStatsPlatform => ({
  ...platform,
  details: platform.details.map((detailRecord) => ({
    ...detailRecord,
    tm: detailRecord.tm ?? null,
    trkid: detailRecord.trkid ? Number(detailRecord.trkid) : 0,
    refid: detailRecord.refid ? Number(detailRecord.refid) : null,
    siteid: detailRecord.siteid ? String(detailRecord.siteid) : "",
  })),
});

export default transformToPlatformStatsPlatform;
